import React from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import DrawerMenu from '../../components/DrawerMenu';
import FileBreadCrumbs from '../../components/FileBreadCrumbs';
import HomeIcon from '@mui/icons-material/Home';
import PolicyLagPanel from '../../components/cluster_debug/PolicyLagPanel';
import TopicThreadDetailsPanel from '../../components/cluster_debug/TopicThreadDetailsPanel';
import MlPodRequestMetricsPanel from '../../components/cluster_debug/MlPodRequestMetricsPanel';
import ResourceUtilizationPanel from '../../components/cluster_debug/ResourceUtilizationPanel';


const ClusterDebugInfoPage = () => {
  const navigate = useNavigate()
  const { clusterName } = useParams()

  return (
    <Grid container>
      <Grid item lg={12} md={12}>
        <Navbar
          leftWidgetList={[
            <IconButton
              size="large"
              color="inherit"
              aria-label="home"
              onClick={() => { navigate("/") }}
              sx={{ marginLeft: '-10px' }}
              key={0}
            >
              <HomeIcon sx={{ fontSize: 40 }} />
            </IconButton>,
            <Typography variant='h4' sx={{ marginLeft: '10px' }} key={1}>{clusterName}</Typography>
          ]}
          rightWidgetList={[<DrawerMenu />, <FileBreadCrumbs clusterName={clusterName} />]}
        />
      </Grid>
      <Grid item lg={12} md={12} sx={{ padding: '15px' }}>
        <Typography variant='h5' color={'#313638'}>{'Cluster Debug Info'}</Typography>
      </Grid>

      {/* Panels */}
      <Grid item lg={12} md={12}>
        <PolicyLagPanel clusterName={clusterName} />
      </Grid>
      <Grid item lg={12} md={12}>
        <ResourceUtilizationPanel clusterName={clusterName} />
      </Grid>
      <Grid item lg={12} md={12}>
        <MlPodRequestMetricsPanel clusterName={clusterName} />
      </Grid>
      <Grid item lg={12} md={12}>
        <TopicThreadDetailsPanel clusterName={clusterName} />
      </Grid>
    </Grid>
  );
}

export default ClusterDebugInfoPage;
